import React, { Component, useEffect, useState } from 'react'
import { includes, result, isEmpty, find } from 'libraries/lodash'
import TableRow from './Row'
import { SeeAllFilters } from '../filters'
import ConfirmDialog from 'components/shared/ConfirmDialog'
import MuiTableBody from '@mui/material/TableBody'
import MuiTableContainer from '@mui/material/TableContainer'
import MuiTable from '@mui/material/Table'
import MuiTableHead from '@mui/material/TableHead'
import TableHeader from './Header'
import url from 'libraries/front-end-core/core/url'
import { MW_DEAL_DETAILS, MW_LIST_DEALS } from 'constants/controllers'
import { pushUrl } from 'libraries/front-end-core/core/history'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const TableContainer = (props) => {
  const {
    parameters,
    searchPhrase,
    showDealType,
    selectedDealType,
    state,
    onSelect,
    selectedDealName,
    deals: { results },
    dealType
  } = props
  const [filteredEnabled, setFiltersEnabled] = useState(false)
  const aol = useSelector(selectAolName)

  useEffect(() => {
    try {
      if (searchPhrase) {
        setFiltersEnabled(true)
      }

      if (parameters) {
        setFiltersEnabled(!isEmpty(JSON.parse(parameters)))
      }
    } catch (error) {
      setFiltersEnabled(false)
    }
  }, [searchPhrase, parameters])

  return (
    <div>
      <MuiTableContainer>
        <MuiTable>
          <MuiTableHead classes={{ root: 'bg-white b bb-medium bt-thick b--dark-sea-green-3 mt1' }}>
            <TableHeader
              {...{ showDealType, selectedDealType, state, onSelect, selectedDealName }}
              isHeader
            />
          </MuiTableHead>
          <TableBody {...{ ...props, aol }} />
        </MuiTable>
      </MuiTableContainer>
      {isEmpty(results) && <TableNoResults {...{ ...props, aol }} />}
      {filteredEnabled && <ClearFiltersDialog {...{ dealType, aol }} />}
    </div>
  )
}

export default TableContainer

class TableBody extends Component {
  getRestrictingValue (paramName, value) {
    const restrictingValues = result(this.props.documentParameters, [paramName, 'restrictingValues'], [])
    const foundValue = find(restrictingValues, p => p.value === value)
    return result(foundValue, 'displayName')
  }

  getMarket = deal => {
    return ['IPO-23', 'SO-26', 'PMA-18'].reduce(
      (acc, param) =>
        acc ||
        this.getRestrictingValue(
          param,
          result(deal, ['params', param, 'value'])
        ),
      undefined
    )
  }

  isSelected = (id, dealType) => {
    const { selectedDeals, selectedDealType } = this.props
    return selectedDealType === dealType || selectedDealType === null || selectedDealType === 'all'
      ? +includes(selectedDeals, id)
      : -2
  }

  toggleSelected = (id, dealType) => e => {
    const { checkSelectionAbility, setSelectedDeals } = this.props
    if (this.isSelected(id, dealType) <= 0) {
      checkSelectionAbility(1, () => {
        setSelectedDeals({ select: [id], dealType })
      })
    } else {
      setSelectedDeals({ deselect: [id], dealType })
    }
  }

  getDealTypeName (type) {
    return result(this.props.eventTypes, [type, 'name'], type)
  }

  render () {
    const {
      deals: { results },
      dealType,
      aol,
      isLogged,
      hasMarketsAccess,
      setSignUpModalIsOpen,
      setUserRolesModalIsOpen
    } = this.props
    const showDealType = dealType === 'all'

    return (
      <MuiTableBody className='bg-white'>
        {results.map((deal, key) => (
          <TableRow
            key={key}
            deal={deal.title}
            dealType={this.getDealTypeName(deal.dealType)}
            date={deal.primaryDate.format('DD/MM/YYYY')}
            market={this.getMarket(deal)}
            checked={this.isSelected(deal.dealId, deal.dealType)}
            onSelect={this.toggleSelected(deal.dealId, deal.dealType)}
            href={url(MW_DEAL_DETAILS, { aol, dealId: deal.dealId })}
            showDealType={showDealType}
            {...{ isLogged, hasMarketsAccess, setSignUpModalIsOpen, setUserRolesModalIsOpen }}
          />
        ))}
      </MuiTableBody>
    )
  }
}

const TableNoResults = props => (
  <div className='tc pa6'>
    <>
      <section className='f4 fw6 pb5 pt6'>
        Search returned no results.{' '}
      </section>
      <SeeAllFilters
        {...props}
        inline={
          <span className='lh-solid vbs ml4'>
            Update filters
          </span>
        }
      />
    </>
  </div>
)

const ClearFiltersDialog = ({ dealType, aol }) => {
  const [open, setOpen] = useState(false)

  return (
    <div className='tc pa6'>
      <a href={null} className='i pointer underline' onClick={() => setOpen(true)}>
        Reset all filters and text search
      </a>
      <ConfirmDialog
        open={open}
        onClose={() => setOpen(false)}
        title='Reset all filters and text search'
        onConfirm={() => pushUrl(url(MW_LIST_DEALS, { aol, dealType }))}
      >
        Are you sure you want to reset all filters?
      </ConfirmDialog>
    </div>
  )
}
